export * from './model-image.model';
export * from './model-image-popup.service';
export * from './model-image.service';
export * from './model-image-dialog.component';
export * from './model-image-delete-dialog.component';
export * from './model-image-detail.component';
export * from './model-image.component';
export * from './model-image.route';



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/model-image/index.ts